import { Platform } from "react-native";
import React from "react";
import {createBottomTabNavigator} from "@react-navigation/bottom-tabs";

import {i18n} from "../common/localization";

import {MainView} from "./MainView";
import HomeIcon from "../icons/HomeIcon";
import RestaurantIcon from "../icons/RestaurantIcon";
import {GymSauna} from "../reservation/GymSauna";
import GymIcon from "../icons/GymIcon";
import {Account} from "../Account";
import {Reservation, reservationType} from "../reservation/Reservation";

const Tab = createBottomTabNavigator();

export const MainTabNavigator = ({onPressLogout, userName, userData}) => {
    const iconSize = 22;
    const isPaymentReturn = Platform.OS === "web"
        && typeof window !== "undefined"
        && new URLSearchParams(window.location.search).has("orderId");

    return (
        <Tab.Navigator
            initialRouteName={isPaymentReturn ? "Account" : "None"}
            screenOptions={({route}) => ({
                headerShown: false,
                tabBarActiveTintColor: route.name === "None" ? "#222222" : "#3A86C8",
                tabBarInactiveTintColor: route.name === "None" ? "white" : "#222222",
                tabBarStyle: {
                    position: "absolute",
                    height: Platform.OS === 'ios' ? 95 : 83,
                    backgroundColor: route.name === "None" ? "transparent" : "#FFF",
                    elevation: 0,
                    borderTopColor: route.name === "None" ? "rgba(255, 255, 255, 0.4)" : "rgba(137, 144, 150, 0.4)"
                },
                tabBarLabelStyle: { fontFamily: "Arsenal-Regular", flex: 0.8, fontSize: 11 },
            })}>
            <Tab.Screen name="None"
                        options={{
                            tabBarItemStyle: { display: "none" }
                        }}>
                {(props) => <MainView {...props} userName={userName} />}
            </Tab.Screen>
            <Tab.Screen name="Restaurant"
                        options={{
                            tabBarLabel: i18n.t("restaurant"),
                            tabBarIcon: ({ color }) => (
                                <RestaurantIcon name="home" color={color} size={iconSize} />
                            ),
                        }}>
                {(props) => <Reservation {...props} type={reservationType.RESTAURANT} />}
            </Tab.Screen>
            <Tab.Screen name="Gym & Sauna" component={GymSauna}
                        options={{
                            tabBarLabel: i18n.t("gymSauna"),
                            tabBarIcon: ({ color }) => (
                                <GymIcon name="home" color={color} size={iconSize} />
                            ),
                        }}/>
            <Tab.Screen name="Account"
                        options={{
                            tabBarLabel: i18n.t("account"),
                            tabBarIcon: ({ color }) => (
                                <HomeIcon name="home" color={color} size={iconSize} />
                            ),
                        }}>
                {(props) => <Account
                    {...props}
                    userName={userName}
                    userData={userData}
                    onLogout={onPressLogout} />}
            </Tab.Screen>
        </Tab.Navigator>
    )
}
